import { trackingPageSchema } from "@redotech/order-tracking-common/tracking-page-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getTrackingPageById = {
  name: "getTrackingPageById" as const,
  input: z.object({ id: zExt.objectId() }),
  output: trackingPageSchema.nullable(),
};
